<template>
  <el-skeleton
    class="skeleton"
    :loading="true"
    animated
  >
    <template slot="template">
      <el-skeleton-item
        variant="image"
        class="cover"
      />
      <el-skeleton-item class="title" variant="p" />
      <el-skeleton-item class="author" variant="p" />
      <div class="bottom">
        <el-skeleton-item class="price" variant="p" />
        <el-skeleton-item class="wishlist" variant="p" />
      </div>
    </template>
  </el-skeleton>
</template>

<script>
export default {
  name: 'Book_Card'
}
</script>

<style lang="scss" scoped>
.skeleton {
  width: 207px;
  padding: 5px 7px;
  background: white;
  .cover {
    height: 280px;
    margin-bottom: 7px;
  }
  .title,
  .author {
    font-size: 13px;
  }
  .title {
    height: 25px;
  }
  .bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .price {
      width: 90px;
    }
    .wishlist {
      width: 40px;
    }
  }
}
</style>
